import { useNavigate, useParams } from 'react-router';

export const usePaths = () => {
  const navigate = useNavigate();
  const { orgSlug } = useParams();

  const navigateToAoiDetails = ({
    aoiId = '',
    queryParameters = {},
    navigateParams = {}
  }) => {
    if (!aoiId) {
      return;
    }
    const queryParams = new URLSearchParams(queryParameters).toString();
    navigate(`/${orgSlug}/aois/${aoiId}?${queryParams}`, navigateParams);
  };

  return {
    navigateToAoiDetails
  };
};
